import "babel-polyfill";
import Vue from "vue";
import Router from "vue-router";
import Home from "../views/Home";
// import Users from "../views/school/Users";
import UsersAdmin from "../views/school/UsersAdmin";
// import UserAdminAddEdit from "../views/school/UserAdminAddEdit";
// import UserAddEdit from "../views/school/UserAddEdit";
// import Configuration from "../views/school/Configuration";
// import ConfigurationAddEdit from "../views/school/ConfigurationAddEdit";
// import Class from "../views/school/Class";
// import ClassAddEdit from "../views/school/ClassAddEdit";
//import Sidebar from "../components/school/Sidebar";

import DashboardOperations from "../views/DashboardOperations";
import DashboardRegistrations from "../views/DashboardRegistrations";
import DashboardHerinschrijving from "../views/DashboardHerinschrijving";
import Login from "../views/Login";
import SignUpEmployee from "../views/schooladmin/EmployeeSignUpAddEdit";
import SignUpEmployeeThanks from "../views/schooladmin/EmployeeSignUp";
import SignUp from "../views/schooladmin/StudentSignUpAddEdit";
import SignUpThanks from "../views/schooladmin/StudentSignUp";
import SignUpCourse from "../views/schooladmin/StudentSignUpCourseAddEdit";
import SignUpCourseThanks from "../views/schooladmin/StudentSignUpCourse";
import reSignUp from "../views/schooladmin/StudentClassProjectionAddEdit";
import reSignUpThanks from "../views/schooladmin/StudentreSignUp";
//--------------- Absentie registratie
import TeacherAbsentStudentView from "../views/schooladmin/TeacherAbsentStudentView";
import reTeacherAbsent from "../views/schooladmin/TeacherAbsentAddEdit";
import reTeacherAbsentThanks from "../views/schooladmin/TeacherAbsentThanks";
import reEmployeeAbsent from "../views/schooladmin/EmployeeAbsentAddEdit";
import reEmployeeAbsentThanks from "../views/schooladmin/EmployeeAbsentThanks";
//----------------OSBOD Events
import OsbodEvent from "../views/schooladmin/OsbodEventAddEdit";
import OsbodEventTeacher from "../views/schooladmin/OsbodEventTeacherAddEdit";
import OsbodEventThanks from "../views/schooladmin/OsbodEventThanks";
import SignUpPap from "../views/schooladmin/StudentSignUpPapAddEdit";
import SignUpPapThanks from "../views/schooladmin/StudentSignUpPap";
//import Navbar from "../components/Navbar";
// import SchoolSubject from "../views/schooladmin/SchoolSubject";
// import SchoolSubjectAddEdit from "../views/schooladmin/SchoolSubjectAddEdit";
// import SubjectGroup from "../views/school/SubjectGroup";
// import SubjectGroupAddEdit from "../views/school/SubjectGroupAddEdit";
// import Coursesgrades from "../views/school/Coursesgrades";


// import TeacherGrades from "../views/school/TeacherGrades";
// import StudentAbsent from "../views/school/StudentAbsent";
// import StudentGrades from "../views/school/StudentGrades";


// import SchoolLevels from "../views/schooladmin/SchoolLevels";

// import AdminClass from "../views/school/AdminClass";
// import AdminClassAddEdit from "../views/school/AdminClassAddEdit";
//import Aanmelden from "../views/schooladmin/Aanmelden";
//import AanmeldenSchool from "../views/schooladmin/AanmeldenSchool";
// import schooltypes from "./schooltypes";
//  import schoolusers from "./schoolusers";
// import grade from "./grade";
// import level from "./level";
// import levelgrade from "./levelgrade";
// import levelstudies from "./levelstudies";
import roles from "./roles";
// import school from "./school";
// import schoolboard from "./schoolboard";
// import sectors from "./sectors";
// import study from "./study";
// import sectorstudy from "./sectorstudy";
// import studylevel from "./studylevel";
// import studylevelsubject from "./studylevelsubject";
// import schoolsubject from "./schoolsubject";
// import schoolsectors from "./schoolsectors";
// import schoolstudies from "./schoolstudies";
// import schoolgrades from "./schoolgrades";
// import schoolclasses from "./schoolclasses";
// import schoolsubjectgrade from "./schoolsubjectgrade";
// import subjecttype from "./subjecttype";
import studentintakes from "./studentintakes";
import studentregistrations from "./studentregistrations";
import studentregistrationsadmin from "./studentregistrationsadmin";
import studentregistrationscursusadmin from "./studentregistrationscursusadmin";
import studentregistrationsintake from "./studentregistrationsintake";
import studentregistrationscoordinator from "./studentregistrationscoordinator";
import employees from "./employees";
import students from "./students";
import mutations from "./mutations";
import employeetimesheets from "./employeetimesheets";
import studentclass from "./studentclass";
import studentclasscursus from "./studentclasscursus";
import employeecohort from "./employeecohort";
import studentcohort from "./studentcohort";
import studentclassprojection from "./studentclassprojection";
import studentclassprojectioncoordinator from "./studentclassprojectioncoordinator";
import osbodevent from "./osbodevent";
import osbodeventteacher from "./osbodeventteacher";
import studentclasscoordinator from "./studentclasscoordinator";
import studentclassaudit from "./studentclassaudit";
import studentovertakeclass from "./studentovertakeclass";
import studentovertakeclasscoordinator from "./studentovertakeclasscoordinator";
import subject from "./subjects";
import schoolclass from "./schoolclass"; 
import study from "./studies";
import teachersubjectclass from "./teachersubjectclass";
import teachersubjectclasscursus from "./teachersubjectclasscursus";
import adminemployeesignup from "./adminemployeesignups";

import teacherabsent from "./teacherabsent";
import teacherabsentstudentview from "./teacherabsentstudentview";
import employeeabsent from "./employeeabsent";
import employeeloaovt from "./employeeloaovt";

import admintask from "./admintasks";
import admintaskovertake from "./admintaskovertakes";
import admintimesheets from "./admintimesheets";
import admintimesheetovertakes from "./admintimesheetovertakes";

import schoolyearstudycost from "./schoolyearstudycost";
import financestudentplacements from "./financestudentplacements";
import financestudentviews from "./financestudentviews";
import financestudents from "./financestudents";

import exam from "./exam";
import examcoordinator from "./examcoordinator";
import examaanmeldingen from "./examaanmeldingen";
import examcursus from "./examcursus";
import portalusers from "./portalusers";
import schoolyear from "./schoolyear";
import changepassword from "./changepassword";
import {
  userHasPortalAdminAccess,
  userMustResetCredentials,
  isDashboardBlockedRole,
  userRoleId,
  dashboardBlockedRedirectPath
} from "./authMeta";

// (selected_system == 'osbod_salary' ? {
//   path: "/",
//   name: "login",
//   components: {
//     main: Login
//   }
// } : {
//   path: "/",
//   components: {
//     aanmelden: Aanmelden
//   }
// },{
//   path: "/login",
//   name: "login",
//   components: {
//     main: Login
//   }
// },{
//   path: '/about',
//   name: 'about',
//   route level code-splitting
//   this generates a separate chunk (about.[hash].js) for this route
//   which is lazy-loaded when the route is visited.
//   component: () => import(/* webpackChunkName: "about" */ './views/About.vue')
// })

//var selected_system = "osbod_salary";

Vue.use(Router);

const router = new Router({
  linkActiveClass: "active",
  routes: [

    {
      path: "/",
      name: "login",
      components: {
        main: Login
      }
    },
    {
      path: "/aanmelden",
      name: "aanmelden",
      components: {
        main: SignUp
      }
    }, {
      path: "/bedankt",
      name: "bedankt",
      components: {
        main: SignUpThanks
      }
    },
    {
      path: "/aanmeldencursus",
      name: "aanmeldencursus",
      components: {
        main: SignUpCourse
      }
    }, {
      path: "/bedanktcursus",
      name: "bedanktcursus",
      components: {
        main: SignUpCourseThanks
      }
    },
    {
      path: "/aanmeldendocent",
      name: "aanmeldendocent",
      components: {
        main: SignUpEmployee
      }
    }, {
      path: "/bedanktdocent",
      name: "bedanktdocent",
      components: {
        main: SignUpEmployeeThanks
      }
    },
    {
      path: "/registrashon",
      name: "registrashon",
      components: {
        main: SignUpPap
      }
    }, {
      path: "/gradisimentu",
      name: "gradisimentu",
      components: {
        main: SignUpPapThanks
      }
    }, 
    {
      path: "/herinschrijving",
      name: "herinschrijving",
      components: {
        main: reSignUp
      }
    }, {
      path: "/bedanktherinschrijving",
      name: "bedanktherinschrijving",
      components: {
        main: reSignUpThanks
      }
    },
    {
      path: "/osbodevent",
      name: "osbodevent",
      components: {
        main: OsbodEvent
      }
    },
        {
      path: "/osbodeventteacher",
      name: "osbodeventteacher",
      components: {
        main: OsbodEventTeacher
      }
    },
    {
      path: "/bedanktosbodevent",
      name: "bedanktosbodevent",
      components: {
        main: OsbodEventThanks
      }
    },


   {
      path: "/teacherabsent",
      name: "teacherabsent",
      components: {
        main: reTeacherAbsent
      }
    }, 
    {
      path: "/teacherabsentstudentview",
      name: "teacherabsentstudentview",
      components: {
        main: TeacherAbsentStudentView
      }
    },
    {
      path: "/bedanktteacherabsent",
      name: "bedanktteacherabsent",
      components: {
        main: reTeacherAbsentThanks
      }
    },
     {
      path: "/employeeabsent",
      name: "employeeabsent",
      components: {
        main: reEmployeeAbsent
      }
    },
{
      path: "/bedanktemployeeabsent",
      name: "bedanktemployeeabsent",
      components: {
        main: reEmployeeAbsentThanks
      }
    },
    {
      path: "/main",
      name: "main",
      components: {
        main: Home
      },
      /* Dashboard and other screens use Home's <router-view name="content">; App.vue only has
         name="main", so content must come from child routes (not parent components.content). */
      children: [
        {
          path: "",
          redirect: "/main/dashboard/operations"
        },
        {
          path: "dashboard/operations",
          name: "dashboard_operations",
          meta: { isDashboard: true },
          components: {
            content: DashboardOperations
          }
        },
        {
          path: "dashboard/registrations",
          name: "dashboard_registrations",
          meta: { isDashboard: true },
          components: {
            content: DashboardRegistrations
          }
        },
        {
          path: "dashboard/herinschrijving",
          name: "dashboard_herinschrijving",
          meta: { isDashboard: true },
          components: {
            content: DashboardHerinschrijving
          }
        },
        {
          path: "/users",
          components: {
            content: UsersAdmin
          }
        }
      ].concat(roles, studentintakes, employees, mutations, studentregistrations, studentregistrationsadmin, students, studentclass,employeetimesheets,studentovertakeclass, studentovertakeclasscoordinator, subject, teachersubjectclass, studentclassaudit, studentclasscoordinator,adminemployeesignup, study, studentclassprojection, employeecohort, studentcohort, schoolclass, teacherabsent,osbodevent,osbodeventteacher, admintask, admintimesheets,employeeabsent,employeeloaovt,schoolyearstudycost, financestudentplacements, financestudentviews, financestudents, exam, examcoordinator, examaanmeldingen, admintaskovertake, admintimesheetovertakes, teacherabsentstudentview, studentregistrationscoordinator, studentregistrationsintake,studentclassprojectioncoordinator, studentclasscursus, teachersubjectclasscursus,examcursus, studentregistrationscursusadmin, portalusers, schoolyear, changepassword)
    }
  ]
});

router.beforeEach(function(to, from, next) {
  if (userMustResetCredentials()) {
    if (to.path === "/change_password") {
      return next();
    }
    return next({ path: "/change_password", replace: true });
  }
  var dashboardRoute = to.matched.some(function(record) {
    return record.meta && record.meta.isDashboard;
  });
  if (
    dashboardRoute ||
    to.path === "/main" ||
    to.path === "/main/" ||
    to.path.indexOf("/main/dashboard") === 0
  ) {
    var ridDash = userRoleId();
    if (isDashboardBlockedRole(ridDash)) {
      return next({ path: dashboardBlockedRedirectPath(ridDash), replace: true });
    }
  }
  var needsPortalAdmin = to.matched.some(function(record) {
    return record.meta && record.meta.requiresPortalAdmin;
  });
  if (needsPortalAdmin) {
    if (userHasPortalAdminAccess()) {
      return next();
    }
    var rawAccess = localStorage.getItem("access");
    if (rawAccess == null || rawAccess === "" || rawAccess === "false") {
      return next({ path: "/" });
    }
    return next({ path: "/main" });
  }
  var needsLoggedIn = to.matched.some(function(record) {
    return record.meta && record.meta.requiresLoggedIn;
  });
  if (needsLoggedIn) {
    var access = localStorage.getItem("access");
    if (access == null || access === "" || access === "false") {
      return next({ path: "/" });
    }
    return next();
  }
  next();
});

export default router;